<template>
	<div class="sale-order">
		<!-- 导航 -->
		<!-- <van-nav-bar
			class="van-nav"
		  title="订单查询"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<headerTemplate title="订单查询"></headerTemplate>
		<div class="max-content">
			<!-- 搜索div -->
			<div class="search-wrap">
				<van-dropdown-menu>
					<van-dropdown-item title="订单编号" ref="订单编号">
						<van-field v-model="orderNum" label="订单编号" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item title="顾客姓名" ref="顾客姓名">
						<van-field v-model="peopleName" label="顾客姓名" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认搜索</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item title="下单时间" ref="下单时间">
						<van-cell title="选择日期区间" :value="date" @click="showDate = true" />
						<van-calendar v-model="showDate" type="range" :min-date="minDate" @confirm="timeConfirm" />
						<div style="padding: 5px 16px;">
							<van-button type="danger" block round @click="onConfirmSearch">确认</van-button>
						</div>
					</van-dropdown-item>
					<van-dropdown-item v-model="orderSta" :options="staOption" @change="onConfirmSearch" />
				</van-dropdown-menu>
			</div>
			<!-- 表格 -->
			<table>
				<tr>
					<th style="width: 50px;">购买用户</th>
					<th>订单号</th>
					<!-- <th>商品名称</th> -->
					<th>订单状态</th>
					<th>下单时间</th>
					<th style="width: 40px;">操作</th>
				</tr>
				<tr v-for="(item, i) in orderList" :key="i">
					<td>{{item.buyer_name}}</td>
					<td>{{item.order_sn}}</td>
					<!-- <td>{{item.goods_name}}</td> -->
					<td>{{item.seller_state_desc}}</td>
					<td>{{item.add_time}}</td>
					<td style="text-align: center;">
						<van-button type="info" size="mini" @click="goOrderInfo(item.order_id)">详情</van-button>
						<van-button type="danger" size="mini" @click="del()">删除</van-button>
						<van-dialog v-model="showDialog" show-cancel-button @confirm="sureDel(item.order_id)">
							<p style="margin: 10px 0;">确定要删除内容吗？</p>
						</van-dialog>
					</td>
				</tr>
			</table>
		</div>
		<van-pagination class="pagination" v-model="currentPage" :total-items="totalNum" :show-page-size="3"
			force-ellipses @change="changePage" />
	</div>
</template>

<script>
	import { getOrderList, delOrder } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'SaleOrder',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 订单编号
				orderNum: '',
				// 顾客姓名
				peopleName: '',
				// 展示日期选择
				showDate: false,
				// 日历显示最小日期
				minDate: new Date(2020, 0, 1),
				// 日期区间
				date: '',
				// 开始时间
				sDate: '',
				eDate: '',
				// 订单状态
				orderSta: '',
				staOption: [
					{ text: '全部', value: '' },
					{ text: '待付款', value: 'state_new' },
					{ text: '待发货', value: 'state_pay' },
					{ text: '待收货', value: 'state_send' },
					{ text: '已收货', value: 'state_success' },
					{ text: '已关闭', value: 'state_cancel' },
					{ text: '已删除', value: 'state_delete' }
				],
				// 获取到的订单列表
				orderList: [],
				// 当前页码
				currentPage: 1,
				// 总共的条数
				totalNum: 0,
				// 是否展示弹窗
				showDialog: false
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			},
			// 改变页码
			changePage() {
				this.getOrderList()
			},
			// 构造日期
			formatDate(date) {
				if ((date.getMonth() + 1) < 10 && date.getDate() < 10) {
					return `${date.getFullYear()}-0${date.getMonth() + 1}-0${date.getDate()}`;
				}
				if ((date.getMonth() + 1) < 10 && date.getDate() >= 10) {
					return `${date.getFullYear()}-0${date.getMonth() + 1}-${date.getDate()}`;
				}
				if ((date.getMonth() + 1) >= 10 && date.getDate() < 10) {
					return `${date.getFullYear()}-${date.getMonth() + 1}-0${date.getDate()}`;
				}
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			// 确认选择的时间
			timeConfirm(date) {
				const [start, end] = date;
				this.showDate = false;
				this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
				this.sDate = `${this.formatDate(start)}`
				this.eDate = `${this.formatDate(end)}`
			},
			// 确认搜索
			onConfirmSearch() {
				this.getOrderList()
				this.$refs['订单编号'].toggle(false)
				this.$refs['顾客姓名'].toggle(false)
				this.$refs['顾客姓名'].toggle(false)
			},
			// 点击删除按钮
			del() {
				this.showDialog = true
			},
			// 确认删除订单
			sureDel(orderId) {
				delOrder(orderId).then(res => {
					alert('删除成功')
				}).catch(error => {
					alert(res.message)
				})
			},
			// 跳转到订单详情页
			goOrderInfo(orderId) {
				this.$router.push({
					name: 'OrderInfo',
					params: {
						orderId: orderId
					}
				})
			},
			// 获取列表信息
			getOrderList() {
				getOrderList({
					order_sn: this.orderNum,
					buyer_name: this.peopleName,
					order_state: this.orderSta,
					query_start_date: this.sDate,
					query_end_date: this.eDate,
					page: this.currentPage
				}).then(res => {
					// 获取到的订单列表
					this.orderList = res.result.return_list
					// 获取到的总共的条数
					this.totalNum = res.result.total
				}).catch(error => {
					// alert('获取失败')
				})
			}
		},
		created() {
			this.getOrderList()
		}
	}
</script>

<style lang="scss" scoped>
	.sale-order {
		font-size: 14px;

		.van-nav {
			z-index: 100;
			position: fixed;
			top: 0;
			width: 100%;
		}

		.max-content {
			z-index: 0;
			/* padding-top: 48px; */
			padding-bottom: 42px;
			height: calc(100% - 100px);
			overflow-y: scroll;
		}

		.pagination {
			position: fixed;
			bottom: 0;
			width: 100%;
		}
	}

	/* .sale-order   ::v-deep.van-nav-bar {
		background-color: #e93b3d;
		color: white;

		.van-icon-arrow-left,
		.van-nav-bar__text,
		.van-nav-bar__title {
			color: white;
		}
	} */

	table {
		/* margin: 5px; */
		table-layout: fixed;
		width: 100%;
		margin: 5px 0;
		border-collapse: collapse;

		td,
		th {
			text-align: center;
			border: 1px solid #e2e1e1;
			word-break: break-all;
			font-size: 12px;
			padding: 5px 0
		}

		.van-button {
			/* margin-bottom: 10px; */
			margin-left: 0;
		}
	}
</style>